import request from '@/utils/request'

// 上传固件
export function uploadFirmware(formData) {
  return request({
    url: '/admin/firmwares',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 覆盖固件
export function overwriteFirmware(id, formData) {
  return request({
    url: `/admin/firmwares/${id}/overwrite`,
    method: 'put',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取固件列表
export function getFirmwareList(params) {
  return request({
    url: '/admin/firmwares',
    method: 'get',
    params
  })
}

// 获取固件详情
export function getFirmwareDetail(id) {
  return request({
    url: `/admin/firmwares/${id}`,
    method: 'get'
  })
}

// 修改固件发布范围
export function updateFirmwareRelease(id, data) {
  return request({
    url: `/admin/firmwares/${id}/release`,
    method: 'put',
    data
  })
}

// 删除固件
export function deleteFirmware(id) {
  return request({
    url: `/admin/firmwares/${id}`,
    method: 'delete'
  })
}

// 一键升级固件
export function upgradeFirmware(id, data) {
  return request({
    url: `/admin/firmwares/${id}/upgrade`,
    method: 'post',
    data
  })
}

// 获取匹配的机器人列表
export function getMatchingRobots(id, params) {
  return request({
    url: `/admin/firmwares/${id}/matching-robots`,
    method: 'get',
    params
  })
}

// 获取固件下载URL
export function getFirmwareDownloadUrl(id) {
  return `/api/admin/firmwares/${id}/download`
}
